import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { useTranslation } from '@frontend/i18n';
import { Button } from '@frontend/design-system';
import { useBulkNavigator } from '../../hooks/use-bulk-navigator';

type SubscribeButtonProps = {
  /** An undefined campaign type means both email and text campaigns should be handled, ie: the drafts page */
  campaignType?: CampaignType;
  trackingIdPrefix: string;
};

// TODO: Figure out if useCurrentAddOnQuota needs to be called when the user changes their subscription and it hasn't updated yet
export const SubscribeButton = ({ campaignType, trackingIdPrefix }: SubscribeButtonProps) => {
  const { t } = useTranslation('bulk-messaging');
  const navigateTo = useBulkNavigator(campaignType);

  return (
    <Button onClick={() => navigateTo.subscriptions()} trackingId={`${trackingIdPrefix}-subscribe-btn`} size='large'>
      {t('Subscribe')}
    </Button>
  );
};
